import { z } from "zod";

export const Steps = [
  {
    id: "basic",
    fields: ["name", "breed", "years", "months", "sex", "reproduction"],
  },
  {
    id: "about",
    fields: ["weightKg", "bodyCondition", "activityLevel", "treatFrequency"],
  },
  {
    id: "treat",
    fields: ["allergies"],
  },
  {
    id: "owner",
    fields: ["ownerName", "ownerEmail", "ownerPhone"],
  },
] as const;

export type StepId = (typeof Steps)[number]["id"];

export const StepIdSchema = z.enum(
  Steps.map((s) => s.id) as [StepId, ...StepId[]]
);
